<template>
  <div class="login-container">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
      auto-complete="on"
      label-position="right"
    >
      <h3 class="title">后台管理系统</h3>

      <el-form-item prop="username">
        <span class="svg-container svg-container_login">
          <svg-icon icon-class="user" />
        </span>
        <el-input
          v-model="loginForm.username"
          name="username"
          type="text"
          auto-complete="on"
          placeholder="账号"
        />
      </el-form-item>

      <el-form-item prop="password">
        <span class="svg-container">
          <svg-icon icon-class="password" />
        </span>
        <el-input
          :type="pwdType"
          v-model="loginForm.password"
          name="password"
          auto-complete="on"
          placeholder="密码"
          @keyup.enter.native="handleLogin"
        />
        <span class="show-pwd" @click="showPwd">
          <svg-icon icon-class="eye" />
        </span>
      </el-form-item>

      <!-- 新增：邮箱 -->
      <!-- <el-form-item prop="email">
        <span class="svg-container">
          <svg-icon icon-class="email" />
        </span>
        <el-input
          v-model="loginForm.email"
          name="email"
          type="text"
          auto-complete="on"
          placeholder="邮箱"
        />
      </el-form-item> -->

      <!-- 新增：验证码 + 发送按钮 -->
      <el-form-item prop="verification_code" class="code-item">
        <span class="svg-container">
          <svg-icon icon-class="message" />
        </span>
        <el-input
          v-model="loginForm.verification_code"
          name="verification_code"
          type="text"
          auto-complete="off"
          placeholder="邮箱验证码"
          @keyup.enter.native="handleLogin"
        />
        <el-button
          class="code-btn"
          type="text"
          :disabled="codeSending || codeCountdown > 0"
          @click="sendEmailCode"
        >
          {{ codeCountdown > 0 ? `${codeCountdown}s后重发` : '发送验证码' }}
        </el-button>
      </el-form-item>

      <el-form-item>
        <el-button
          :loading="loading"
          type="primary"
          style="width: 100%"
          @click.native.prevent="handleLogin"
        >
          登录
        </el-button>
      </el-form-item>

      <el-row class="keep-login">
        <el-checkbox v-model="loginForm.keepLogin">保持登录</el-checkbox>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'Login',
  data() {
    const validateName = (rule, value, callback) => {
      if (!value || value.length <= 0) {
        callback(new Error('账号不能为空'))
      } else {
        callback()
      }
    }
    const validatePass = (rule, value, callback) => {
      if (!value || value.length < 6) {
        callback(new Error('密码不能小于6位'))
      } else {
        callback()
      }
    }
    const validateEmail = (rule, value, callback) => {
      callback()
      const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!value) {
        callback(new Error('邮箱不能为空'))
      } else if (!emailReg.test(value)) {
        callback(new Error('邮箱格式不正确'))
      } else {
        callback()
      }
    }
    const validateEmailCode = (rule, value, callback) => {
      callback()
      if (!value || value.length <= 0) {
        callback(new Error('验证码不能为空'))
      } else {
        callback()
      }
    }

    return {
      loginForm: {
        username: '',
        password: '',
        email: '',
        verification_code: '',
        keepLogin: false,
      },
      loginRules: {
        username: [
          { required: true, trigger: 'blur', validator: validateName },
        ],
        password: [
          { required: true, trigger: 'blur', validator: validatePass },
        ],
        // email: [{ required: false, trigger: 'blur', validator: validateEmail }],
        verification_code: [
          { required: false, trigger: 'blur', validator: validateEmailCode },
        ],
      },
      loading: false,
      codeSending: false,
      codeCountdown: 0,
      codeTimer: null,
      pwdType: 'password',
    }
  },

  beforeDestroy() {
    if (this.codeTimer) {
      clearInterval(this.codeTimer)
      this.codeTimer = null
    }
  },

  methods: {
    showPwd() {
      this.pwdType = this.pwdType === 'password' ? '' : 'password'
    },

    startCodeCountdown() {
      this.codeCountdown = 60
      if (this.codeTimer) clearInterval(this.codeTimer)
      this.codeTimer = setInterval(() => {
        this.codeCountdown -= 1
        if (this.codeCountdown <= 0) {
          clearInterval(this.codeTimer)
          this.codeTimer = null
        }
      }, 1000)
    },

    async sendEmailCode() {
      // 仅校验邮箱字段
      this.$refs.loginForm.validateField('username', async (emailErr) => {
        console.log(emailErr)

        if (emailErr) return
        try {
          this.codeSending = true
          await request({
            url: '/api/backend/login/sendCode', // 按后端实际接口修改
            method: 'post',
            data: { username: this.loginForm.username },
          })
          this.$message.success('验证码已发送，请查收邮箱')
          this.startCodeCountdown()
        } catch (e) {
          this.$message.error('验证码发送失败')
        } finally {
          this.codeSending = false
        }
      })
    },

    async verifyEmailCode() {
      await request({
        url: '/api/backend/login/verifyCode', // 按后端实际接口修改
        method: 'post',
        data: {
          username: this.loginForm.username,
          code: this.loginForm.verification_code,
        },
      })
    },

    handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (!valid) {
          console.log('error submit!!')
          return false
        }

        this.loading = true
        try {
          // 先校验邮箱验证码，通过后再登录
          // await this.verifyEmailCode()

          await this.$store.dispatch('Login', this.loginForm)
          this.$router.push({ path: '/' })
        } catch (e) {
          // this.$message.error((e && e.message) || '登录失败，请检查验证码')
        } finally {
          this.loading = false
        }
      })
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: $bg;

  .login-form {
    position: absolute;
    left: 0;
    right: 0;
    width: 520px;
    padding: 35px 35px 15px 35px;
    margin: 120px auto;
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
    &_login {
      font-size: 20px;
    }
  }

  .title {
    font-size: 26px;
    color: $light_gray;
    margin: 0 auto 40px auto;
    text-align: center;
    font-weight: bold;
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .keep-login {
    text-align: right;
    margin-top: -20px;
    padding: 10px 0;
  }

  .code-item {
    position: relative;
    .code-btn {
      position: absolute;
      right: 10px;
      top: 6px;
      z-index: 2;
    }
  }
}
</style>

<style rel="stylesheet/scss" lang="scss">
$bg: #2d3a4b;
$light_gray: #eee;

.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;
    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      &:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: #fff !important;
      }
    }
  }
  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
  .keep-login .el-checkbox {
    color: #fff;
    opacity: 0.8;
  }
}
</style>
